module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/InfluencerExample/1_1-412afe03cde21a4395b273273bedf8ac.png";